import React from 'react';
import { Lozenge } from '../../../../../../../../../../CommonComponents/OPL/Lozenge/Lozenge';
import { Text } from '../../../../../../../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../../../../../../../CommonUtils/formatNumber';
import { Badge } from '../../../../../../../../../../CommonComponents/OPL/Badge/Badge';
import { EdgeWrapper } from './Edge.styles';
import { AdditionalInfoDTO } from '../../../../api/useEstatePlanningFlowQuery';
import { AdditionalInfo } from '../../../AdditionalInfo/AdditionalInfo';
import { useIsPdf } from '../../../../../../../../../hooks/useIsPdf';

interface Props {
  label?: string;
  title?: string;
  value?: number | null;
  isSecondDeath?: boolean;
  showTopLine?: boolean;
  additionalInfo?: AdditionalInfoDTO;
}

export const Edge = ({
  title,
  value = null,
  label,
  isSecondDeath,
  showTopLine,
  additionalInfo,
}: Props) => {
  const isPrint = useIsPdf();

  return (
    <EdgeWrapper showTopLine={showTopLine}>
      {isSecondDeath && (
        <Text
          fontSize="h6"
          mb="4"
          fontWeight={600}
          color="neutral.500"
          textTransform="uppercase"
          letterSpacing="wide"
        >
          After 2th Death
        </Text>
      )}

      <Text
        fontSize="h6"
        mb="4"
        fontWeight={600}
        color="neutral.500"
        textTransform="uppercase"
        letterSpacing="wide"
      >
        {title}
      </Text>

      {value !== null && (
        <Badge size="huge">
          {formatCurrency(value)}

          {additionalInfo && !isPrint && (
            <AdditionalInfo additionalInfo={additionalInfo} variant="primary" />
          )}
        </Badge>
      )}

      {label && <Lozenge>{label}</Lozenge>}
    </EdgeWrapper>
  );
};
